"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityViewedByFacilityAdminPropertiesDto = instanceOfOrientationOpportunityViewedByFacilityAdminPropertiesDto;
exports.OrientationOpportunityViewedByFacilityAdminPropertiesDtoFromJSON = OrientationOpportunityViewedByFacilityAdminPropertiesDtoFromJSON;
exports.OrientationOpportunityViewedByFacilityAdminPropertiesDtoFromJSONTyped = OrientationOpportunityViewedByFacilityAdminPropertiesDtoFromJSONTyped;
exports.OrientationOpportunityViewedByFacilityAdminPropertiesDtoToJSON = OrientationOpportunityViewedByFacilityAdminPropertiesDtoToJSON;
exports.OrientationOpportunityViewedByFacilityAdminPropertiesDtoToJSONTyped = OrientationOpportunityViewedByFacilityAdminPropertiesDtoToJSONTyped;
const OrientationOpportunityViewedByFacilityAdminSource_1 = require("./OrientationOpportunityViewedByFacilityAdminSource");
/**
 * Check if a given object implements the OrientationOpportunityViewedByFacilityAdminPropertiesDto interface.
 */
function instanceOfOrientationOpportunityViewedByFacilityAdminPropertiesDto(value) {
    if (!('orientationOpportunityId' in value) || value['orientationOpportunityId'] === undefined)
        return false;
    if (!('source' in value) || value['source'] === undefined)
        return false;
    return true;
}
function OrientationOpportunityViewedByFacilityAdminPropertiesDtoFromJSON(json) {
    return OrientationOpportunityViewedByFacilityAdminPropertiesDtoFromJSONTyped(json, false);
}
function OrientationOpportunityViewedByFacilityAdminPropertiesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orientationOpportunityId': json['orientationOpportunityId'],
        'source': (0, OrientationOpportunityViewedByFacilityAdminSource_1.OrientationOpportunityViewedByFacilityAdminSourceFromJSON)(json['source']),
    };
}
function OrientationOpportunityViewedByFacilityAdminPropertiesDtoToJSON(json) {
    return OrientationOpportunityViewedByFacilityAdminPropertiesDtoToJSONTyped(json, false);
}
function OrientationOpportunityViewedByFacilityAdminPropertiesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orientationOpportunityId': value['orientationOpportunityId'],
        'source': (0, OrientationOpportunityViewedByFacilityAdminSource_1.OrientationOpportunityViewedByFacilityAdminSourceToJSON)(value['source']),
    };
}
//# sourceMappingURL=OrientationOpportunityViewedByFacilityAdminPropertiesDto.js.map